import { emptyDraft } from "./model";
import { Modal, Button, FullScreenLoading } from "src/Components";
import SahraConnections from "src/Pages/Sahra/SahraConnections";
import { AddForm } from "./AddOrderForm";
import { OrderItemDetails } from "./OrderDetails/OrderDetails";
import { DraftOrderItemDetails } from "./OrderDetails/DraftOrderDetails";
import { OrderItemDetailsPlaceholder } from "./OrderDetails/OrderDetailsPlaceholder";
import { MatrixExecutionTabs } from "./Tables/ExecutionTabs";
import { OptionsModal } from "./Modals/OptionsModal";
import { CriteriaModal } from "./Modals/CriteriaModal";
import { PreviewModal } from "./Modals/PreviewModal";
import { EditCriteriaModal } from "./Modals/EditCriteriaModal";
import { useCoveredMatrixOrder } from "./useCoveredMatrixOrder";

export const CoveredMatrixOrder = () => {
  const {
    optionDefaults,
    setOptionDefaults,
    accounts,
    baseInstruments,
    options,
    draft,
    modal,
    setModal,
    editingGroup,
    editingOptions,
    editingMarketWatch,
    selectedGroup,
    tableVersion,
    detailTableVersion,
    formLoadVersion,
    loading,
    preview,
    changeDraft,
    accountName,
    instrumentName,
    optionName,
    openEdit,
    openDetails,
    reloadSelectedDetails,
    openTradeDetails,
    handleGroupsDeleted,
    openPreview,
    create,
    openConnections,
    updateCriteria,
  } = useCoveredMatrixOrder();
  return (
    <div className="w-full max-w-full flex flex-col gap-3 mt-7 px-3" dir="rtl">
      {loading ? <FullScreenLoading /> : null}
      <div className="flex w-full max-w-full flex-col items-start gap-3 xl:flex-row">
        <aside className="w-full xl:w-[340px] xl:shrink-0">
          <AddForm
            key={formLoadVersion}
            draft={draft}
            setDraft={changeDraft}
            bases={baseInstruments}
            options={options}
            onReset={() => changeDraft(emptyDraft())}
            onOptions={(defaults) => {
              setOptionDefaults(defaults);
              setModal("options");
            }}
            onCriteria={() => setModal("criteria")}
            onSubmit={openPreview}
            loading={loading}
          />
        </aside>
        <div className="min-w-0 max-w-full flex-1 flex flex-col gap-4 overflow-hidden">
          <div className="min-w-0">
            {selectedGroup ? (
              <OrderItemDetails
                group={selectedGroup}
                tableVersion={detailTableVersion}
                baseName={
                  selectedGroup.baseSymbolName ||
                  instrumentName(selectedGroup.baseIsin)
                }
                accountName={accountName(selectedGroup.sahraUserId)}
              />
            ) : draft.baseIsin ? (
              <DraftOrderItemDetails
                draft={draft}
                accounts={accounts}
                baseName={instrumentName(draft.baseIsin)}
                options={options}
              />
            ) : (
              <OrderItemDetailsPlaceholder />
            )}
          </div>
          <MatrixExecutionTabs
            selectedGroupId={selectedGroup?.id}
            onSelectGroup={openDetails}
            onSelectTradeGroup={openTradeDetails}
            onEditGroup={openEdit}
            onGroupChanged={reloadSelectedDetails}
            onGroupsDeleted={handleGroupsDeleted}
            tableVersion={tableVersion}
          />
        </div>
      </div>
      {modal === "options" ? (
        <OptionsModal
          newItemDefaults={optionDefaults}
          draft={draft}
          setDraft={changeDraft}
          options={options}
          baseName={instrumentName(draft.baseIsin)}
          onClose={() => setModal(null)}
        />
      ) : null}
      {modal === "criteria" ? (
        <CriteriaModal
          draft={draft}
          setDraft={changeDraft}
          optionName={optionName}
          onBack={() => setModal(null)}
          onSubmit={() => setModal(null)}
        />
      ) : null}
      {modal === "preview" && preview ? (
        <PreviewModal
          preview={preview}
          baseReferencePrice={draft.manualBaseReferencePrice}
          onClose={() => setModal(null)}
          onSubmit={openConnections}
        />
      ) : null}
      {modal === "connections" && preview ? (
        <Modal
          onClose={() => setModal("preview")}
          modalBoxClassName="!w-[1320px] !max-w-[99vw]"
          UI={
            <div className="flex flex-col items-center gap-3 p-4" dir="rtl">
              <SahraConnections
                initialSearchParam={{
                  userIds: Array.from(
                    new Set(preview.rows.map((row) => row.accountId)),
                  ),
                }}
              />
              <Button
                variant="contained"
                text="ارسال"
                onClick={create}
                loading={loading}
                disabled={loading || !preview.rows.length}
                className="!w-28"
              />
            </div>
          }
        />
      ) : null}
      {modal === "edit" && editingGroup ? (
        <EditCriteriaModal
          loading={loading}
          group={editingGroup}
          options={editingOptions}
          marketWatch={editingMarketWatch}
          accountName={
            editingGroup.accountName || accountName(editingGroup.sahraUserId)
          }
          baseName={
            editingGroup.baseSymbolName || instrumentName(editingGroup.baseIsin)
          }
          optionName={optionName}
          onClose={() => setModal(null)}
          onSubmit={updateCriteria}
        />
      ) : null}
    </div>
  );
};

export default CoveredMatrixOrder;
